import { FC, ReactNode } from "react";

import {
  getRidePassengerTooltipContent,
  onActivateKeyDown,
} from "@ryde/shared";

import { FramerTooltip } from "../../../tooltips";

interface IBookingPassengerProps {
  passengerId?: number;
  passengerFirstName?: string;
  passengerLastName?: string;
  passengerWorkerCode?: string;
  canOpenPassengerCard: boolean;
  onPassengerClick: (passengerId: number) => void;
}

export const BookingPassenger: FC<IBookingPassengerProps> = ({
  passengerId,
  passengerFirstName,
  passengerLastName,
  passengerWorkerCode,
  canOpenPassengerCard,
  onPassengerClick,
}) => {
  const hasWorkerCode = Boolean(passengerWorkerCode);
  const canClick = canOpenPassengerCard && Boolean(passengerId);

  const renderWorkerCode = (): ReactNode => {
    if (!hasWorkerCode) {
      return null;
    }

    if (canClick) {
      return (
        <span
          className="course-schedule__passenger-code course-schedule__passenger-code--clickable"
          onClick={() => onPassengerClick(passengerId!)}
          onKeyDown={onActivateKeyDown(() => onPassengerClick(passengerId!))}
          role="button"
          tabIndex={0}
        >
          #{passengerWorkerCode}
        </span>
      );
    }

    return (
      <span className="course-schedule__passenger-code">
        #{passengerWorkerCode}
      </span>
    );
  };

  return (
    <span className="course-schedule__booking-passenger">
      <FramerTooltip
        content={getRidePassengerTooltipContent(
          passengerFirstName,
          passengerLastName,
          passengerWorkerCode,
          passengerId || 0,
        )}
      >
        <span className="course-schedule__passenger-text">
          {renderWorkerCode()}
          {hasWorkerCode && " "}
          {passengerFirstName || ""} {passengerLastName || ""}
        </span>
      </FramerTooltip>
    </span>
  );
};
